import { Grid } from "@mui/material"
import AppBar from "@mui/material/AppBar"
import Toolbar from "@mui/material/Toolbar"
import { makeStyles } from "tss-react/mui"
import { useAppSelector } from "../../modules/store/storeHooks"
import { UserType } from "../../modules/login/loginTypes"
import { selectEffectiveUserType } from "../../modules/context/contextSelectors"
import { ContextDisplay } from "../../modules/context/components/ContextDisplay"
import { NewsBellNavItem } from "./components/NewsBellNavItem/NewsBellNavItem"
import { AvatarMenu } from "./components/AvatarMenu"
import { LayoutContainer } from "./components/LayoutContainer"
import { drawerWidthCompact, drawerWidthNormal } from "./LeftBar"
import { AwaitingApprovalNavItem } from "./components/AwaitingApprovalNavItem"
import { HelpNavItem } from "./components/HelpNavItem"
import { MatchEnvironment } from "../../modules/environment/components/MatchEnvironment"
import { EnvironmentType } from "../../modules/environment/envTypes"
import { MatchActualUserType } from "../../modules/accessControl/MatchActualUserType"
import { InstructionButton } from "./components/supportInstructions/InstructionButton"
import { NotificationTopBarButton } from "./components/NotificationTopBar/NotificationTopBarButton"
import { QaEnvWarning } from "./components/QaEnvWarning"
import { MainTopBarNewButton } from "./components/MainTopBarNewButton"

type StyleProps = Readonly<{
    compactNav: boolean
}>

const useStyles = makeStyles<StyleProps>()((_theme, { compactNav }) => ({
    appBar: {
        //backgroundColor: theme.palette.common.black,
    },
    toolbar: {
        paddingLeft: compactNav ? drawerWidthCompact : drawerWidthNormal,
    },
    toolbarRightArea: {
        gap: "1rem",
    },
    bell: {
        marginRight: "-0.25rem",
    },
}))

type TopBarProps = Readonly<{
    environmentRoutePath: string | undefined
    compactNav: boolean
}>

export function TopBar({ environmentRoutePath, compactNav }: TopBarProps) {
    const { classes } = useStyles({ compactNav })
    const userType = useAppSelector(selectEffectiveUserType)
    const isMerchantUser = userType === UserType.MERCHANT

    return (
        <AppBar position="sticky" color="inherit" elevation={2} className={classes.appBar}>
            <MatchEnvironment environments={[EnvironmentType.QA]}>
                <Toolbar className={classes.toolbar} disableGutters>
                    <QaEnvWarning />
                </Toolbar>
            </MatchEnvironment>
            <Toolbar className={classes.toolbar} disableGutters>
                <LayoutContainer>
                    <Grid container wrap="nowrap" justifyContent="space-between" alignItems="center">
                        <ContextDisplay />

                        <Grid
                            container
                            item
                            wrap="nowrap"
                            width="auto"
                            flexGrow={0}
                            alignItems="center"
                            className={classes.toolbarRightArea}
                        >
                            {isMerchantUser ? <MainTopBarNewButton isMerchantUser={isMerchantUser} /> : null}

                            <MatchEnvironment
                                environments={[EnvironmentType.Local, EnvironmentType.Test, EnvironmentType.Demo]}
                            >
                                {isMerchantUser && <AwaitingApprovalNavItem />}
                            </MatchEnvironment>

                            <MatchActualUserType userTypes={[UserType.SUPPORT]}>
                                <InstructionButton />
                            </MatchActualUserType>

                            <MatchEnvironment
                                environments={[EnvironmentType.Local, EnvironmentType.Test, EnvironmentType.Demo]}
                            >
                                {isMerchantUser && <NotificationTopBarButton />}
                            </MatchEnvironment>

                            <NewsBellNavItem urlPrefix={environmentRoutePath} className={classes.bell} />

                            <MatchEnvironment
                                environments={[EnvironmentType.Local, EnvironmentType.Test, EnvironmentType.Demo]}
                            >
                                <HelpNavItem />
                            </MatchEnvironment>

                            <AvatarMenu urlPrefix={environmentRoutePath} />
                        </Grid>
                    </Grid>
                </LayoutContainer>
            </Toolbar>
        </AppBar>
    )
}
